
import MessageBox from '@nextrequestco/components/src/components/MessageBox/MessageBox.vue'
import NrFormLabel from '@nextrequestco/components/src/components/form-elements/nr-form-label.vue'
import NrEditor from '@nextrequestco/components/src/components/NrEditor/nr-editor.vue'
import NrSentry from '../../../../utils/nr_sentry'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'RequestTextModal',
  components: { MessageBox, 'nr-editor': NrEditor, NrFormLabel },
  data() {
    return {
      requestText: ''
    }
  },
  computed: {
    ...mapState('request_show', [
      'displayEditRequestTextBox',
      'currentAction',
      'request'
    ])
  },

  methods: {
    ...mapActions('request_show', [
      'setDisplayEditRequestTextBox',
      'updateRequest',
      'fetchTimeline'
    ]),

    updateRequestText(value: string): void {
      this.requestText = value
    },

    handleSubmit(): void {
      this.updateRequest({
        request_id: this.request.pretty_id,
        request_text: this.requestText
      })
        .then(() => {
          this.fetchTimeline({
            pretty_id: this.request.pretty_id
          })
          this.setDisplayEditRequestTextBox(false)
          this.$toasted.success('Request text updated successfully')
        })
        .catch((e) => {
          this.$toasted.error('There was an error updating the request')
          NrSentry.captureError(e)
        })
    }
  }
}
